<template>
  <base-modal 
    :id="modalId" 
    :ok-handler="okHandler" 
    :title="title" 
    :ok-button-text="okButtonText"
    :ok-button-class="okButtonClass"
  >
    <div>
      <p>{{ content }}</p>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal';

export default {
  name: 'WarningModal',
  components: { BaseModal },
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    okButtonText: {
      type: String,
      default: 'OK',
    },
    okButtonClass: {
      type: String,
      default: 'btn-warning',
    }
  },
  data() {
    return {
      modalId: 'warning-modal',
    }
  },
  methods: {
    isValid: function(values) {
      console.log('isValid: ', values);
      return true;
    },
    handleSubmit: function(e) {
      if (e) e.preventDefaul();
      const values = {};
      if (this.isValid(values)) {
        // TODO: Some API Action Here
        // TODO: Depending on the status of the action, close the modal, or pass the closer as a callback
        console.log('submitting', values);
        this.closeModal();
      }
    },
    okHandler: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    closeModal: async function() {
      await this.$nextTick();
      this.$bvModal.hide(this.modalId);
    }
  },
}
</script>
